import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';

function initTextImageSlider(root = document) {
    const blocks = root.querySelectorAll('[data-text-image-slider]');

    blocks.forEach((blockElement) => {
        if (blockElement.dataset.swiperInitialized === '1') return;
        blockElement.dataset.swiperInitialized = '1';

        const imageSwiper = blockElement.querySelector('.block-text-image-slider__image-swiper');
        const textSwiper = blockElement.querySelector('.block-text-image-slider__text-swiper');

        if (!imageSwiper || !textSwiper) return;

        const imageSlidesCount = imageSwiper.querySelectorAll('.swiper-slide').length;
        const textSlidesCount = textSwiper.querySelectorAll('.swiper-slide').length;
        const prevEl = blockElement.querySelector('.block-hero-slider__nav--prev');
        const nextEl = blockElement.querySelector('.block-hero-slider__nav--next');

        if (imageSlidesCount < 1 || textSlidesCount < 1) {
            console.warn('Brak slajdów w sliderze');
            return;
        }

        // Inicjalizacja image slidera BEZ LOOP
        const imageSwiperInstance = new Swiper(imageSwiper, {
            modules: [EffectFade, Navigation, Pagination, Autoplay],
            loop: false, // WYŁĄCZONY LOOP
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            allowTouchMove: true,
            speed: 600,
            navigation: {
                prevEl,
                nextEl
            },
            on: {
                slideChange: function() {
                    const currentIndex = this.activeIndex;
                    textSwiperInstance.slideTo(currentIndex, 600);
                    updateActiveSlide(currentIndex);
                }
            }
        });

        // Inicjalizacja text slidera
        const textSwiperInstance = new Swiper(textSwiper, {
            slidesPerView: 3,
            spaceBetween: 20,
            loop: false,
            allowTouchMove: true,
            speed: 600,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            on: {
                slideChange: function() {
                    const currentIndex = this.activeIndex;
                    imageSwiperInstance.slideTo(currentIndex, 600);
                    updateActiveSlide(currentIndex);
                }
            }
        });

        const textSlideElements = textSwiper.querySelectorAll('.swiper-slide');

        // Funkcja aktualizacji active slide i progress line
        const updateActiveSlide = (index) => {
            textSlideElements.forEach(s => s.classList.remove('swiper-slide-active'));

            if (textSlideElements[index]) {
                textSlideElements[index].classList.add('swiper-slide-active');
            }

            updateProgressLine(index);
        };

        // Update progress line
        const updateProgressLine = (index) => {
            // Wyczyść wszystkie progress linie
            textSlideElements.forEach(slide => {
                const progressLine = slide.querySelector('.block-text-image-slider__progress-line');
                if (progressLine) {
                    progressLine.style.width = '0%';
                }
            });

            // Ustaw progress line dla aktywnego slajdu
            if (textSlideElements[index]) {
                const progressLine = textSlideElements[index].querySelector('.block-text-image-slider__progress-line');
                if (progressLine) {
                    setTimeout(() => {
                        progressLine.style.width = '100%';
                    }, 50);
                }
            }
        };

        // Klik na tekst zmienia image
        textSlideElements.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                imageSwiperInstance.slideTo(index, 600);
                textSwiperInstance.slideTo(index, 600);
                updateActiveSlide(index);
            });
        });

        // Pozycjonowanie strzałek na środku zdjęć
        const positionArrows = () => {
            const imageSwiperHeight = imageSwiper.offsetHeight;
            const centerPosition = imageSwiperHeight / 2;

            if (prevEl) {
                prevEl.style.top = `${centerPosition}px`;
                prevEl.style.transform = 'translateY(-50%)';
            }
            if (nextEl) {
                nextEl.style.top = `${centerPosition}px`;
                nextEl.style.transform = 'translateY(-50%)';
            }
        };

        // Wywołaj po załadowaniu
        positionArrows();

        // Aktualizuj przy zmianie rozmiaru okna
        window.addEventListener('resize', positionArrows);

        // Aktualizuj po załadowaniu obrazków
        const images = imageSwiper.querySelectorAll('img');
        images.forEach(img => {
            if (img.complete) {
                positionArrows();
            } else {
                img.addEventListener('load', positionArrows);
            }
        });

        // Inicjalizacja
        updateActiveSlide(0);
    });
}

document.addEventListener('DOMContentLoaded', () => initTextImageSlider(document));

if (window.acf) {
    window.acf.addAction('render_block_preview/type=text-image-slider', (blockEl) => {
        initTextImageSlider(blockEl);
    });
}

export default initTextImageSlider;
